module.exports = __webpack_public_path__ + "static/media/listingImg2.36ae6276.svg";